import { type FC } from 'react';

import { Box } from '../../Box';
import { Icon } from '../../Icon';
import { Text } from '../../Typography';

export type ReviewItemProps = {
  /**
   * Label for the review item (e.g., "Communication", "Property", "Lodging")
   */
  label: string;
  /**
   * Rating value from 1 to 5
   */
  rating: number;
};

const ReviewItem: FC<ReviewItemProps> = ({ label, rating }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <Text fontWeight="semibold">{label}</Text>

      <Box display="flex" alignItems="center" gap="var(--spacing-2)">
        <Icon variant="StarSolid" size="large" fill="var(--surface-action-2)" />
        <Text fontWeight="semibold">{rating.toFixed(1)}</Text>
      </Box>
    </Box>
  );
};

export default ReviewItem;
